import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../constants/Languages.js';
import {withRouter} from 'react-router';

const AboutPblDefault = ({ clang, pageData }) => {
    if (!pageData.content) {
        return null;
    }

    return (
        <div className="about-pbl__subpage-content-container">
            <div dangerouslySetInnerHTML={{__html: pageData.content.rendered}}></div>
        </div>
    );
};

AboutPblDefault.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(AboutPblDefault));



// WEBPACK FOOTER //
// ./src/components/about/subpages/AboutPblDefault.js